export enum IncomeRemarketingEnum {
  action = 'action',
  asset = 'asset',
  atag = 'atag',
  id = 'id',
  remarketing = 'remarketing',
  Remarketing = 'Remarketing',
  utm_campaign = 'utm_campaign',
  utm_content = 'utm_content',
  utm_medium = 'utm_medium',
  utm_source = 'utm_source',
  utm_term = 'utm_term',
  timestamp = 'timestamp',
}

export type IncomeRemarketing = {
  [key in IncomeRemarketingEnum]?: string;
};
